import Client from './prismicConfig';
import * as prismic from '@prismicio/client';

const getQuery = async (path, value) => {
  const type = path === 'document.type' ? value : 'portfolio_item';

  if (path === 'document.type') {
    return Client.getByType(type, { pageSize: 100 });
  }

  return Client.getByType(type, {
    pageSize: 100,
    filters: [prismic.filter.at(path, value)],
  });
};

export const fetchData = async (setCtx, path, value) => {
  try {
    const res = await getQuery(path, value);
    setCtx({ data: res.results, loading: false, error: false });
  } catch (err) {
    console.error('Error: ', err.message || err);
    setCtx({ loading: false, error: true });
  }
};
